export default {
  singleLabel: "Paramètre",
  storeNamespace: 'axiloc_setting',
  authFeature: 'axiloc-setting',
  editRouteName: "AxilocSettingEdit",
  formComponentName: 'AxilocSettingForm',
  hideActionNewButton: true,
  hideActionDeleteButton: true,
  hideActionCsvButton: true,
  hideActionPdfButton: true,
  // AC-002 — La sélection « Produits à la Une » (réglage `home_new_products`) a son propre
  // écran : cf. components/FeaturedProduct. L'ordre et le plafond de 10 n'entrent pas dans
  // ce formulaire générique.
  fields: [{
      name: 'address',
      label: "Adresse",
      type: 'textarea',
      inForm: true,
      required: true
    },
    {
      name: 'phone_number',
      label: "Téléphone",
      type: 'text',
      inForm: true,
      required: true
    },
    {
      name: 'email_address',
      label: "Email",
      type: 'email',
      inForm: true,
      required: true
    },
    // Liens « Nous suivre » du footer boutique : chacun n'apparaît qu'une fois renseigné,
    // ils ne sont donc pas obligatoires.
    {
      name: 'sharepoint_url',
      label: "Lien Sharepoint (footer)",
      type: 'text',
      inForm: true,
      required: false
    },
    {
      name: 'vivaengage_url',
      label: "Lien VivaEngage (footer)",
      type: 'text',
      inForm: true,
      required: false
    },
    // Interrupteur de la rubrique en boutique (cf. LocationForAccountAvailability côté API).
    // Choix fournis par AxilocSettingForm (`location_for_account_enabled_options`).
    {
      name: 'location_for_account_enabled',
      label: "Location pour compte en boutique",
      type: 'select',
      description: "Désactivée : la rubrique, son catalogue et le formulaire de demande disparaissent de la boutique. Le suivi des demandes déjà passées reste accessible.",
      inForm: true,
      required: true
    },
    // Interrupteur de l'engagement longue durée en boutique (cf. LongTermAvailability côté API).
    // Choix fournis par AxilocSettingForm (`long_term_enabled_options`).
    {
      name: 'long_term_enabled',
      label: "Location longue durée avec engagement en boutique",
      type: 'select',
      description: "Désactivée : le choix de l'engagement disparaît du panier et les commandes passent en location standard. Les engagements en cours ne sont pas modifiés.",
      inForm: true,
      required: true
    },
  ]
}



// WEBPACK FOOTER //
// ./src/components/AxilocSetting/config.js